import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.5 12.5h-10v1.667h10V12.5zm0-6.667h-10V7.5h10V5.833zm-10 5h15V9.167h-15v1.666zm0 6.667h15v-1.667h-15V17.5zm0-15v1.667h15V2.5h-15z" fill="#54585D" /></svg>);